import * as React from "react";
import List from "antd/es/list";
import Card from "antd/es/card";
import Flex from "antd/es/flex";
import Collapse from "antd/es/collapse";
import { RecipientIcon } from "./RecipientIcon";
import { roundTokens } from "./utils";
import { decimals, reservesBreakpoints } from "./constants";
import { ExchangeToken, ReservesType } from "./types";

export interface ReservesDisplayProps {
    token: ExchangeToken;
    reserves: ReservesType;
}

export const ReservesDisplay: React.FunctionComponent<ReservesDisplayProps> = (props) => {
    const labels = props.token === "LLD" ? {
        ll: "Native LLD reserves",
        eth: "LLD Ethereum reserves",
        sol: "LLD Solana reserves",
        trx: "LLD Tron reserves",
    } : {
        ll: "USDT LL reserves",
        eth: "USDT Ethereum reserves",
        sol: "USDT Solana reserves",
        trx: "USDT Tron reserves",
    };
    return (
        <Collapse
            items={[{
                label: "Reserves",
                key: "reserves",
                children: (
                    <List
                        grid={reservesBreakpoints}
                        dataSource={[
                            { title: labels.ll, value: props.reserves.ll, decimals: decimals.Liberland[props.token], type: "Liberland" } as const,
                            { title: labels.eth, value: props.reserves.eth, decimals: decimals.Ethereum[props.token], type: "Ethereum" } as const,
                            { title: labels.sol, value: props.reserves.sol, decimals: decimals.Solana[props.token], type: "Solana" } as const,
                            { title: labels.trx, value: props.reserves.trx, decimals: decimals.Tron[props.token], type: "Tron" } as const,
                        ]}
                        renderItem={(item) => (
                            <List.Item>
                                <Card title={item.title}>
                                    <Flex wrap gap="10px">
                                        {roundTokens(BigInt(item.value), item.decimals, 2)}
                                        <RecipientIcon chain={item.type} />
                                    </Flex>
                                </Card>
                            </List.Item>
                        )}
                    />
                ),
            }]}
        />
    )
};